var _path, _path2, _path3, _rect, _rect2, _rect3, _circle, _rect4, _rect5, _rect6, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCsalLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1519,
    height: 1522,
    viewBox: "0 0 1519 1522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M560.598 1323.8C250.988 1214.51 89.4301 872.565 198.721 562.956V562.956C308.012 253.346 648.431 88.598 958.04 197.889V197.889C1267.65 307.18 1429.21 649.124 1319.92 958.734V958.734C1210.63 1268.34 870.208 1433.09 560.598 1323.8V1323.8Z",
    fill: "#116599"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M692.5 881.3C674.7 881.3 659.2 878.6 646 873.2C633 867.8 621.1 859.3 610.3 847.7L644.2 813.5C651.6 821.3 659.5 827.3 667.9 831.5C676.3 835.5 685.8 837.5 696.4 837.5C705.4 837.5 712.3 836 717.1 833C722.1 829.8 724.6 825.5 724.6 820.1C724.6 815.1 722.8 811 719.2 807.8C715.6 804.4 710.8 801.5 704.8 799.1C699 796.5 692.5 794.1 685.3 791.9C678.3 789.5 671.2 786.7 664 783.5C657 780.1 650.5 776 644.5 771.2C638.7 766.4 634 760.4 630.4 753.2C626.8 746 625 737.1 625 726.5C625 712.9 628.2 701.3 634.6 691.7C641.2 682.1 650.3 674.7 661.9 669.5C673.5 664.3 687 661.7 702.4 661.7C717.8 661.7 732 664.3 745 669.5C758 674.7 768.7 681.9 777.1 691.1L742.9 725C736.5 718.6 730 713.8 723.4 710.6C716.8 707.4 709.6 705.8 701.8 705.8C694.4 705.8 688.6 707.1 684.4 709.7C680.2 712.3 678.1 716 678.1 720.8C678.1 725.6 679.9 729.5 683.5 732.5C687.1 735.5 691.8 738.2 697.6 740.6C703.6 742.8 710.1 745.1 717.1 747.5C724.3 749.9 731.4 752.7 738.4 755.9C745.4 759.1 751.8 763.2 757.6 768.2C763.6 773.2 768.4 779.5 772 787.1C775.6 794.7 777.4 803.9 777.4 814.7C777.4 835.9 769.9 852.3 754.9 863.9C740.1 875.5 719.3 881.3 692.5 881.3ZM783.152 878L865.652 665.3H917.552L999.152 878H943.052L881.552 699.2H901.052L838.052 878H783.152ZM833.252 840.8V798.2H950.552V840.8H833.252Z",
    fill: "#F6FBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M559.5 869C545.7 869 533.2 865.8 522 859.4C511 852.8 502.2 843.9 495.6 832.7C489.2 821.5 486 809 486 795.2C486 781.4 489.2 769 495.6 758C502.2 746.8 511 738 522 731.6C533.2 725.2 545.7 722 559.5 722C570.1 722 580 724 589.2 728C598.4 732 606.2 737.6 612.6 744.8L598.8 758.9C594 753.5 588.2 749.4 581.4 746.6C574.6 743.6 567.3 742.1 559.5 742.1C549.5 742.1 540.6 744.4 532.8 749C525 753.6 518.9 759.9 514.5 767.9C510.1 775.7 507.9 784.8 507.9 795.2C507.9 805.4 510.1 814.6 514.5 822.8C518.9 830.8 525 837.1 532.8 841.7C540.6 846.3 549.5 848.6 559.5 848.6C567.5 848.6 574.9 847.2 581.7 844.4C588.5 841.4 594.3 837.2 599.1 831.8L613.2 845.9C606.6 853.3 598.6 859 589.2 863C580 867 570.1 869 559.5 869Z",
    fill: "#F6FBFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 879,
    y: 812,
    width: 26,
    height: 44,
    fill: "#116599"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 872.616,
    y: 780,
    width: 34.0461,
    height: 131.11,
    transform: "rotate(19.4308 872.616 780)",
    fill: "#116599"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 873,
    y: 778.195,
    width: 33.7766,
    height: 131.11,
    transform: "rotate(-19.1968 873 778.195)",
    fill: "#116599"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 874.5,
    cy: 819.5,
    r: 7.5,
    fill: "#F6FBFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 495.292,
    y: 731.056,
    width: 55.6241,
    height: 163.896,
    transform: "rotate(-44.7332 495.292 731.056)",
    fill: "#116599"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 552,
    y: 714.326,
    width: 55.6241,
    height: 55.8317,
    transform: "rotate(-9.65234 552 714.326)",
    fill: "#116599"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 892,
    y: 662,
    width: 108,
    height: 221,
    fill: "#116599"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M891.9 878V665.3H945.6V878H891.9ZM934.5 878V831.8H1037.1V878H934.5Z",
    fill: "#F6FBFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M904.5 757.5C904.5 770.203 903.15 742.5 891 742.5C878.85 742.5 873 772.703 873 760C873 747.297 876.35 725 888.5 725C900.65 725 904.5 744.797 904.5 757.5Z",
    fill: "#F6FBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsalLogo);
export default __webpack_public_path__ + "static/media/csal-logo.12aa20f0d71eb32017f801263801ee89.svg";
export { ForwardRef as ReactComponent };